import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { ActionReducer, createReducer, on } from '@ngrx/store';
import { Tree } from '@design/models/trees.model';
import { fromTreesActions } from './trees.action';
import { TreesState } from './trees.state';

export const adapter: EntityAdapter<Tree> = createEntityAdapter<Tree>({ });
export const TreesInitialState: TreesState = adapter.getInitialState();
export const { selectAll } = adapter.getSelectors();


export const treesReducer: ActionReducer<TreesState> = createReducer(
    TreesInitialState,
    on(fromTreesActions.AddTree, (state, data) => {
        return adapter.addOne(data.trees, state);
    }),
    on(fromTreesActions.SelectTree, (state, { trees }) => {
        return { ...state, selectedTreeId: trees?.id };
    }),
    // on(fromTreesActions.TreeBoundChange, (state, { tree: { id, diameter, position, vertexIds } }) => {
    //         return adapter.updateOne(
    //             {
    //                 id,
    //             changes: { diameter, position, vertexIds },
    //             },
    //             state
    //         );
    // }),
    on(fromTreesActions.TreeConfigurationChange, (state, { trees }) => {
        return adapter.updateOne(
            {
                id: trees.id,
                changes: {
                    ...trees,
                },
            },
            state
        );
    }),

  on(fromTreesActions.UpdateTree, (state, { tree }) => {
    return adapter.updateOne(
      {
        id: tree.id,
        changes: {
          ...tree,
        },
      },
      state
    );
  }),
    on(fromTreesActions.DeleteTree, (state, { tree }) => {
        return adapter.removeOne(tree.id, state);
    }), on(fromTreesActions.AddManyTrees, (state, data) => {
        return adapter.addMany(data.trees, state);
    })
);
